module.exports = __webpack_public_path__ + "img/nodeType2.aaf7bf2c.svg";